/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";

import { FieldArrayPropTypes } from "../lib/types";
import {
  StyledButton,
  StyledDeleteButton,
  StyledDeleteImage,
  StyledHelperDiv,
  StyledLabel,
  StyledListItem,
  StyledWarningTextarea,
} from "../lib/styles";

const trash = require("../../../svg/trash.svg");

const Warnings = ({
  disabled,
  handleFieldChange,
  value,
}: FieldArrayPropTypes): React.ReactElement => {
  return (
    <>
      <StyledLabel>Warnings</StyledLabel>
      <StyledHelperDiv>
        This field is optional. Examples include:
        <ul>
          <StyledListItem>
            This reward can only be redeemed in-store and cannot be used online.
          </StyledListItem>
          <StyledListItem>
            This reward expires 3 months after it is claimed.
          </StyledListItem>
        </ul>
      </StyledHelperDiv>
      {value.map((warning, index) => {
        return (
          <div key={index}>
            <StyledWarningTextarea
              data-testid={`warning-${index}`}
              disabled={disabled}
              id={`warning-${index}`}
              name={`warning-${index}`}
              onChange={(event): void => {
                const updatedWarnings = [...value];
                updatedWarnings[index] = event.target.value;
                handleFieldChange({ warnings: updatedWarnings });
              }}
              type="text"
              value={warning}
            />
            <StyledDeleteButton
              disabled={disabled}
              onClick={(): void => {
                const updatedWarnings = [...value];
                updatedWarnings.splice(index, 1);
                handleFieldChange({ warnings: updatedWarnings });
              }}
              size="small"
              testId={`remove-warning-${index}`}
              variant="secondary"
            >
              <StyledDeleteImage src={trash} alt="trash icon" />
            </StyledDeleteButton>
          </div>
        );
      })}
      <StyledButton
        disabled={disabled}
        onClick={(): void => {
          const updatedWarnings = [...value, ""];
          handleFieldChange({ warnings: updatedWarnings });
        }}
        size="small"
        testId="add-warning-button"
        variant="primary"
      >
        Add Warning
      </StyledButton>
    </>
  );
};

export default Warnings;
